(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsActivitiesAction', rmsActivitiesAction);

    function rmsActivitiesAction() {
        return {
            restrict: 'E',
            templateUrl: 'common/app/components/activities/list-panel/activities-action',
            controller: rmsActivitiesActionCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {}
        };
    }

    function rmsActivitiesActionCtrl(ActivitiesService, $timeout) {
        var vm = this;
        this.$onInit = function() {
            init();

            vm.add = add;
            vm.discard = ActivitiesService.discard;
        }

        function init() {
            ActivitiesService.sync(vm);
            console.log('activity actions', vm);
        }

        function add() {
            $timeout(() => {
                ActivitiesService.save();
            });
        }
    }
})();